import * as $ from 'jquery';

interface PredicateRange {
    min?: number
    max?: number
}

const changeHandler = function () {
    const $this: JQuery = $(this);
    const value = $this.val();
    const predicateData = $this.attr('data-toggle-on-change-predicate');
    const target: any = $($this.data('toggle-on-change'));

    try {
        var predicate: any = JSON.parse(predicateData);
    } catch (e) {
        // It is ok to not have a predicate
    }

    var matches = evaluatePredicate(predicate, value);

    if (matches) {
        target.collapse('show');
    } else {
        target.collapse('hide');
    }
};

function evaluatePredicate(predicate, value): boolean {
    if (!predicate) {
        // if no predicate is defined, the toggle occures on any change
        return true;
    }

    return Object.keys(predicate)
        .map(rule => {
            const expectation = predicate[rule];
            return rules[rule] && rules[rule](expectation, value);
        })
        .every(v => v);
}

const rules = {
    'value': (expectedValue: string, value) => expectedValue === value,
    'range': (expectedRange: PredicateRange, value) => expectedRange &&
        expectedRange.min <= value &&
        (!expectedRange.max || expectedRange.max >= value)
};

$('[data-toggle-on-change]').on('change', changeHandler);
